import { render, staticRenderFns } from "./komchat-for-brands.vue?vue&type=template&id=1bc02581&"
import script from "./komchat-for-brands.vue?vue&type=script&lang=js&"
export * from "./komchat-for-brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports